import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import PouchDB from "pouchdb-browser";
import { useDoc } from "use-pouchdb";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import LogoutIcon from "@mui/icons-material/Logout";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/DeleteForever";
import PersonIcon from "@mui/icons-material/Person";
import { useConfirm } from "material-ui-confirm";
import { useSetRecoilState } from "recoil";
import { useQuery } from "@tanstack/react-query";
import { getStores, getQuestionnaire } from "./utilities/datalayer";
import { current, stores, questionnaire } from "./utilities/state";
import Login from "./Login";
import ModalQSCSelect from "./views/components/ModalQSCSelect";

PouchDB.plugin(require('pouchdb-upsert'));
const db = new PouchDB('delfornoqsc', { revs_limit: 1 });

function App() {

    const confirm = useConfirm();
    const total = 196;
    const user = JSON.parse(localStorage.getItem('user'));
    const [accesstoken, setAccessToken] = useState('');
    const { data: dataStores, error: errorStores, isError: isErrorStores, isLoading: isLoadingStores } = useQuery(['stores'], getStores);
    const { data: dataQuestionnaire, error: errorQuestionnaire, isError, isLoading: isLoadingQuestionnaire } = useQuery(['questionnaire'], getQuestionnaire);
    const [inProgress, setInProgress] = useState([]);
    const setCurrent = useSetRecoilState(current);
    const setStores = useSetRecoilState(stores);
    const setQuestionnaire = useSetRecoilState(questionnaire);
    const navigator = useNavigate();
    const [open, setOpen] = useState(false);

    useEffect(() => {

        if (!isLoadingQuestionnaire && dataQuestionnaire) {
            setQuestionnaire(dataQuestionnaire);
        }

        if (!isLoadingStores && dataStores) {
            setStores(dataStores);
        }

        setAccessToken(localStorage.getItem('access_token'));

        if (dataStores) {
            refreshDocs();
        }

    }, [dataStores]);

    const refreshDocs = () => {

        let _inProgress = [];

        db.allDocs({
            include_docs: true,
            attachments: true
        }).then(function (result) {
            _.each(result.rows, (qsc) => {
                let found = _.find(dataStores, { 'storeId': qsc.doc.storeId });

                if (found) {

                    let completed = _.countBy(qsc.doc.answers, o => o.score !== '').true;

                    if (!completed) {
                        completed = 0;
                    }

                    let percentage = (completed / total) * 100;

                    let store = {
                        qscId: qsc.id,
                        storeId: qsc.doc.storeId,
                        name: found.storeName,
                        completed,
                        percentage
                    }

                    _inProgress.push(store);
                }

            });

            _inProgress = _.orderBy(_inProgress, ['name']);
            setInProgress(_inProgress);

        }).catch(function (err) {
            console.log(err);
        });
    }

    const logout = () => {
        localStorage.setItem('access_token', '');
        window.location.href = "/";
    }

    const editQSC = (qscId) => {
        setCurrent(qscId);
        navigator("/qsc");
    }

    const downloadQSC = (qscId) => {
        db.get(qscId).then((doc) => {
            const link = document.createElement("a");
            var blob = new Blob([JSON.stringify(doc)], { type: "text/plain;charset=utf-8" });
            link.href = URL.createObjectURL(blob);
            link.download = "database.txt";
            link.click();
            URL.revokeObjectURL(link.href);
        });
    }

    const deleteQSC = (qscId, name) => {

        confirm({ description: `This will permanently delete this qsc for ` + name + `.` })
            .then(() => {
                db.get(qscId).then((doc) => {
                    db.remove(doc).then(() => {
                        refreshDocs();
                    });
                })
            })
            .catch();
    }

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        (accesstoken) ?
            <>
                <Container sx={{ padding: 1, backgroundColor: '#dedede', height: '100vh' }}>
                    <Box sx={{ flexGrow: 1, marginBottom: 1 }}>
                        <AppBar position="static">
                            <Toolbar sx={{ backgroundColor: '#000' }}>
                                <Box>
                                    <img src={process.env.PUBLIC_URL + "/logo.png"} style={{ width: '80px' }} alt="Del Forno" />
                                </Box>
                                <Box>
                                    <Typography component="div" sx={{ flexGrow: 1, ml: 1 }}>
                                        Quality Control Audit System
                                    </Typography>
                                    <Typography component="div" sx={{ flexGrow: 1, ml: 1, fontSize: 10 }}>
                                        0.16 04/10/2023
                                    </Typography>
                                </Box>
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginLeft: 8, marginRight: 8 }} onClick={() => handleOpen()}>
                                    <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ padding: 0, ml: '2px' }}>
                                        <NoteAddIcon />
                                    </IconButton>
                                    <Typography sx={{ fontSize: 12 }}>New</Typography>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginLeft: 8 }}  onClick={() => logout()}>
                                    <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ padding: 0, ml: '4px' }}>
                                        <LogoutIcon />
                                    </IconButton>
                                    <Typography sx={{ fontSize: 12 }}>Logout</Typography>
                                </div>
                            </Toolbar>
                        </AppBar>
                    </Box>
                    <Box sx={{ display: 'flex', marginBottom: 1, align: 'right', justifyContent: "flex-end", marginRight: 2 }}>
                        <PersonIcon /> <Box sx={{ paddingLeft: 1, fontWeight: 'bold' }}>{user.firstname}</Box>
                    </Box>
                    <Paper elevation={2} sx={{ backgroundColor: '#fff' }}>
                        {inProgress.map((store, index) => {
                            return <Box sx={{ display: 'flex', padding: 1 }} key={index} >
                                <Box sx={{ flex: 1, padding: 1, fontWeight: 'bold' }} onClick={() => editQSC(store.qscId)}>
                                    {store.name}
                                </Box>
                                <Box sx={{ padding: 1 }}>
                                    {store.completed}/{total} ({parseInt(store.percentage) + '%'})
                                </Box>
                                <Box item xs={12} md={2}>
                                    <IconButton size="small" edge="start" color="inherit" aria-label="menu" onClick={() => downloadQSC(store.qscId)}>
                                        <DownloadIcon />
                                    </IconButton>
                                </Box>
                                <Box item xs={12} md={2}>
                                    <IconButton size="small" edge="start" color="inherit" aria-label="menu" onClick={() => deleteQSC(store.qscId, store.name)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                        })}
                    </Paper>
                </Container>
                <ModalQSCSelect open={open} handleClose={handleClose} />
            </> : <Login />
    );
}

export default App;
